import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

// Props are not used, but are required for proper media rules
const styles: ComponentStylesProps<string> = {
  body: {
    width: '100%',
    '@media(max-width: 450px)': {
      width: 'auto',
    },
  },
  modalTitle: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
    },
    letterSpacing: '0.02rem',
    marginBottom: '0.4rem',
    marginTop: '2rem',
    textAlign: 'center',
  },
  subtitle: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    textAlign: 'center',
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    padding: '0.4rem 0 3.6rem 0',
    maxWidth: '55rem',
    margin: '0 auto 0',
  },
  form: {
    marginBottom: '4rem',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '2rem',
    [breakpoints.lg.down]: {
      marginBottom: '2rem',
    },
  },
  inputContainer: {
    margin: '0 -1.2rem',
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: '0.8rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [breakpoints.md.down]: {
      padding: 0,
      margin: 0,
    },
  },
  sectionTitle: {
    textTransform: 'uppercase',
    fontSize: '1.2rem',
    lineHeight: '2rem',
    fontWeight: '400',
    color: colors.neutral[600],
    paddingBottom: '0.8rem',
    borderBottom: `0.1px solid ${colors.neutral[300]}`,
    marginBottom: '1.2rem',
  },
  bookmarkedSectionTitle: {
    textTransform: 'uppercase',
    fontSize: '1.2rem',
    lineHeight: '2rem',
    fontWeight: '400',
    color: colors.neutral[600],
    margin: 0,
  },
  bookmarkedPlansSubtitle: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: colors.neutral[700],
    paddingBottom: '0.8rem',
    marginBottom: '2rem',
    marginTop: '0.5rem',
    borderBottom: `0.1px solid ${colors.neutral[300]}`,
  },
  footer: {
    margin: [0],
    marginTop: '0.4rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionsBlock: {
    margin: [0],
    maxWidth: '42.4rem',
    display: 'flex',
    gap: '2.4rem',
    justifyContent: 'center',
    '@media(max-width: 540px)': {
      maxWidth: '100%',
      width: '100%',
      '& button': {
        width: '50%',
        minWidth: 'auto',
      },
    },
  },
  fullInputLayout: {
    width: '100%',
    padding: '0 1.2rem 3.6rem 1.2rem',
  },
  halfInputLayout: {
    width: 'calc(50% - 2.4rem)',
    padding: '0 1.2rem 3.6rem 1.2rem',
    [breakpoints.md.down]: {
      width: '100%',
    },
  },
  thirdInputLayout: {
    width: 'calc(33.3% - 2.4rem)',
    padding: '0 1.2rem 3.6rem 1.2rem',
    [breakpoints.md.down]: {
      width: '100%',
    },
  },
  notesTextArea: {
    padding: '2rem 0 0',
  },
  productLineSections: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    marginBottom: '3.6rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
